import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { PasswordInput } from "@/components/PasswordInput";
import { Label } from "@/components/ui/label";
import { formatApiErrorDetail } from "@/lib/api";
import { ShieldCheck, Loader2 } from "lucide-react";

export default function AdminLogin() {
  const { user, login, logout } = useAuth();
  const navigate = useNavigate();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (user && (user.role === "admin" || user.role === "operator")) navigate("/admin/panel", { replace: true });
  }, [user, navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    try {
      const u = await login(username, password);
      if (u.role === "admin" || u.role === "operator") {
        navigate("/admin/panel", { replace: true });
      } else {
        await logout();
        setError("Akun ini bukan akun admin/operator.");
        setLoading(false);
      }
    } catch (e) {
      setError(formatApiErrorDetail(e.response?.data?.detail) || "Gagal masuk");
      setLoading(false);
    }
  };

  return (
    <div className="grain min-h-screen flex items-center justify-center bg-slate-900 px-6">
      <div className="absolute top-0 left-0 w-full h-1.5 bg-gradient-to-r from-indigo-500 via-teal-500 to-amber-400" />
      <form onSubmit={submit} className="w-full max-w-sm bg-white rounded-3xl p-8 shadow-2xl animate-pop relative z-[2]">
        <div className="w-14 h-14 rounded-2xl bg-slate-900 text-white flex items-center justify-center mx-auto"><ShieldCheck className="w-7 h-7" /></div>
        <h1 className="font-display text-2xl font-bold text-slate-800 text-center mt-4">Panel Admin</h1>
        <p className="text-sm text-slate-500 text-center mt-1">Khusus administrator & operator sekolah.</p>
        <div className="mt-6 space-y-4">
          <div>
            <Label>Username</Label>
            <Input value={username} onChange={(e) => setUsername(e.target.value)} required className="mt-1.5 h-12 rounded-xl" placeholder="admin" data-testid="admin-username-input" />
          </div>
          <div>
            <Label>Kata Sandi</Label>
            <PasswordInput value={password} onChange={(e) => setPassword(e.target.value)} required className="mt-1.5 h-12 rounded-xl" placeholder="••••••••" data-testid="admin-password-input" />
          </div>
          {error && <p className="text-sm text-rose-600 bg-rose-50 rounded-xl px-4 py-2.5" data-testid="admin-login-error">{error}</p>}
          <Button type="submit" disabled={loading} className="w-full h-12 rounded-xl bg-slate-900 hover:bg-slate-800 text-base font-semibold" data-testid="admin-login-btn">
            {loading && <Loader2 className="w-5 h-5 mr-2 animate-spin" />} Masuk
          </Button>
        </div>
      </form>
    </div>
  );
}
